import { Component, Inject, Input} from 'ng-metadata/core';
import {DateUtils} from '../../../../nddUtils/dateUtils.service';
import {ConfigurationUtil} from '../../../../nddUtils/configurationUtil.service';



    @Component({
        directives:[], //directives you want to use in your directive
        providers: [], //put here all angular1 modules which this directive needs
        'selector': 'prm-saved-query-filter',
        templateUrl: 'components/search/searchResult/savedQueriesList/savedQueryFilter/saved-query-filter.html',
        'inputs': ['item']
     })

export class PrmSavedQueryFilter {
    @Input() item: any;
    private preFilterMap;
    private prefixCodesForTypes;

    constructor(private configurationUtil : ConfigurationUtil,
        private dateUtils: DateUtils,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('savedSearches') private savedSearches
        ) {
        this.preFilterMap = {
            'pfilter': 'material_type',
            'lang': 'language',
            'creationdate': 'publication_date',
            'dr_s': 'DateRangeStart',
            'dr_e': 'DateRangeEnd',
            'rtype': 'material_type'
        };

        this.prefixCodesForTypes = {
            'material_type': 'search-advanced.mediaType.option.',
            'language': 'search-advanced.language.option.',
            'publication_date': '',
            'DateRangeStart': 'search-advanced.DateRange.label.',
            'DateRangeEnd': 'search-advanced.DateRange.label.'
        };
    }

    convertDate(date) {
        // Check if the original date contains year 0000 or if conversion results in current year when input was 0000
        if (date && date.includes('0000')) {
            return 'Invalid Date';
        }
        return this.dateUtils.convertIlsDateStringToPrimoDateString(date);
    }


    decodeString(str: string) {
        return decodeURIComponent(str);
    }

    /**
     * Strips HTML tags and dangerous characters from a value before it is
     * used inside a translate key or translate-default attribute.
     * Normal pfilter/facet values (e.g. "books", "articles") contain only
     * alphanumeric characters and are unaffected.
     */
    sanitizeValue(value: string): string {
        if (!value) { return ''; }
        // Remove full HTML tags first, then strip any remaining < > " ' characters
        return value.replace(/<[^>]*>/g, '').replace(/[<>"']/g, '');
    }

    private getPfilterMap(pfilterType) {
        return this.preFilterMap[pfilterType];
    }

    private getPrefixCodeAccordingToType(pfilterType) {
        return this.prefixCodesForTypes[pfilterType];
    }

    private defTrans(facet) {

        let decodedValue = this.decodeString(facet.split(',')[2]);
        let lab: string;
        if (facet.split(',')[0] === "tlevel") {
            lab = "facets.facet.tlevel" + "." + decodedValue;
        }
        else if (facet.split(',')[0] === "searchcreationdate") {
            return this.decodeString(facet.split(',')[2]).slice(0, -1) + '-' + this.decodeString(facet.split(',')[3]).slice(1);
        }

        else {

            lab = "facets.facet.facet_" + facet.split(',')[0] + "." + decodedValue;
        }
        let translated = this.$translate.instant(lab);
        return (translated === lab) ? decodedValue : translated;

    }

    private facetNameTransfer(facet) {
        if (facet.split(',')[0] === "searchcreationdate") {
            return "creationdate"
        }

        return facet.split(',')[0];

    }

    private isPrimoVELocalFacet(facet){
        if (facet.split(',')[0].startsWith("lds") && this.configurationUtil.getBackendSystem() === 'suprima') {
            return true;
        }
        return false;
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/savedQueriesList/savedQueryFilter/savedQueryFilter.directive.ts